<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Kernkompetenz · Planung</p>

      <h2 class="presentation-page__title">Kernkompetenz Planung</h2>

      <p class="presentation-page__text">
        Vor der ersten Schraube steht eine technisch saubere, normengerechte Planung.
      </p>

      <div
        class="presentation-page__body presentation-page__body--split presentation-page__body--split-media-40"
      >
        <div class="presentation-page__column presentation-page__column--text">
          <ul class="presentation-page__list">
            <li v-for="item in listItems" :key="item">{{ item }}</li>
          </ul>
        </div>

        <div class="presentation-page__column presentation-page__column--media">
          <figure class="presentation-page__figure">
            <img
              class="presentation-page__image"
              src="/img/master_presentation/master_presentation_page_17.png"
              alt="Montage einer Photovoltaik-Unterkonstruktion auf einem Kiesdach"
            />
          </figure>
          <p class="presentation-page__image-caption bg-blue">
            Eigene Planer · Statik · Netzanschluss
          </p>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage17',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      listItems: [
        'Technische Detailplanung für maximalen Kundennutzen',
        'Systemauslegung nach geltenden Normen und Gesetzen',
        'Netz- und EVU-Abstimmung für problemlosen Anschluss',
        'Herstellerunabhängige Komponentenauswahl',
        'Terminplanung und Vorbereitung (Kunde, intern)',
      ],
    };
  },
};
</script>
